module.exports = __webpack_public_path__ + "img/gb9113_12_b.prt.cb90f559.jpg";